import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserProductSpecialPricings {
  constructor($scope, UserProductService, GeoService, UserService) {
    $scope.parseInt = function(value) {
      return parseInt(value);
    };

    $scope.$watch('pricing.country_id', function() {
      if ($scope.pricing && $scope.pricing.country_id) {
        GeoService.get_cities($scope.pricing.country_id).then(function(data) {
          $scope.dialog_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.pricing.city_id}))
            $scope.pricing.city_id = null;
        });
      }
    });

    $scope.set_user_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.pricing.buyer_id = ui.item.id;
          $scope.buyer_user_company = ui.item.value;
          $(this).val('');
          $scope.$apply();
          $scope.load_buyer_user_products(ui.item.id);
        }
      });
    };

    $scope.load_buyer_user_products = function(buyer_id) {
      UserProductService.get_user_products(buyer_id).then(function(data) {
        _.each(data.user_products, function(user_product) {
          if (user_product.product) {
            $scope.user_products.push({
              id: user_product.id,
              title: user_product.product.title
            });
          }
        });
      });
    };

    $scope.remove_user = function() {
      $scope.pricing.buyer_id = null;
      $scope.buyer_user_company = null;
      $('input.user_company').val('');
      $scope.user_products = [];
      $scope.pricing.user_product_id = null;
    };

    $scope.load_special_pricings = function() {
      $scope.loading = true;
      UserProductService.get_user_products_special_pricings(window.user_id).then(function(data) {
        $scope.pricings = data.pricings;
        $scope.buyer_pricings = _.groupBy(data.pricings, 'buyer_id');
        $scope.buyers = data.buyers;
        $scope.loading = false;
      });
    };

    $scope.save_pricing = function() {
      if (!$scope.pricing.buyer_id || !$scope.pricing.user_product_id) {
        alert('Please select a buyer and a user product!');
      } else {
        $scope.saving_pricing = true;
        UserProductService.save_special_pricing($scope.pricing).then(function(data) {
          if (data.success) {
            $scope.saving_pricing = false;
            $.fancybox.close();
            $scope.load_special_pricings();
          }
        });
      }
    };

    $scope.add_pricing = function() {
      $scope.pricing = angular.copy(window.pricing);
      $scope.pricing.user_id = null;
      $scope.buyer_user_company = null;
      $scope.user_products = [];
      $('input.user_company').val('');
      window.openFancyboxDialog('div#pricing_dialog');
    };

    $scope.edit_pricing = function(pricing) {
      $scope.pricing = pricing;
      $scope.buyer_user_company = pricing.buyer_user_company;
      window.openFancyboxDialog('div#pricing_dialog');
      $scope.user_products = [];
      $scope.load_buyer_user_products($scope.pricing.buyer_id);
    };

    $scope.delete_pricing = function(pricing_id) {
      if (confirm('Are you sure you want to delete this pricing?')) {
        UserProductService.delete_special_pricing(pricing_id).then(function(data) {
          if (data.success)
            $scope.load_special_pricings();
        });
      }
    };

    $scope.stock_types = [
      {
        id: 1,
        title: 'Reels'
      },
      {
        id: 0,
        title: 'Sheets'
      }
    ];

    $scope.delivery_terms = [
      {
        id: 3,
        title: 'FCA'
      },
      {
        id: 1,
        title: 'CFR'
      },
      {
        id: 2,
        title: 'DAP'
      }
    ];

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.load_special_pricings();
      $scope.user_products = [];
      $scope.countries = window.countries;
      $scope.set_user_autocomplete($('input.user_company'));
      $scope.user_type = window.user_type;
      $scope._ = _;
    };

    $scope.init();

  }
}

UserProductSpecialPricings.$inject = ['$scope', 'UserProductService', 'GeoService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-product-special-pricings.ctrl.js